import Vue from 'vue'
import Router from 'vue-router'
import ThemeFive from '@/themes/theme-five'
import Login from '@/components/Accounts/Login/login'
import SignUp from '@/components/Accounts/SignUp/signup'
import Forgot from '@/components/Accounts/Forgot/forgot'
import SeiOnHiragana from '@/components/Modules/Hiragana/sei-on/SeiOn'
import DakuOnHiragana from '@/components/Modules/Hiragana/daku-on/DakuOn'
import HandakuOnHiragana from '@/components/Modules/Hiragana/handaku-on/HandakuOn'
import SeiOnKatakana from '@/components/Modules/Katakana/sei-on/SeiOn'
import Numbers from '@/components/Modules/Numbers/Number'
import UnitOne from '@/components/Modules/extraPractices/unit1/unitOne'
import UnitTwo from '@/components/Modules/extraPractices/unit2/unitTwo'
import Nouns from '@/components/Modules/extraPractices/writing/Nouns'
import Adjectives from '@/components/Modules/extraPractices/writing/Adjectives'
import Verbs from '@/components/Modules/extraPractices/writing/Verbs'
import ExtraVocab from '@/components/Modules/extraPractices/extravocab/Extra'
import Tips from '@/components/Modules/Tips/Tips'
import Greeting from '@/components/Modules/Greetings/Greeting'
import Malaysia from '@/components/Modules/Malaysia/Malaysia'
import ListeningHiragana from '@/components/Modules/extraPractices/listening/hiragana/hiragana'
import ListeningKatakana from '@/components/Modules/extraPractices/listening/katakana/katakana'
import IntermediateNouns from '@/components/Modules/intermediate/Nouns'
import IntermediateAdjectives from '@/components/Modules/intermediate/Adjectives'
import IntermediateVerbs from '@/components/Modules/intermediate/Verbs'
import IntermediateListening from '@/components/Modules/intermediate/Listening'
import BusinessGreetings from '@/components/Modules/business/greetings'
import BusinessMaps from '@/components/Modules/business/maps'
import BusinessPositions from '@/components/Modules/business/positions'
import BusinessBow from '@/components/Modules/business/bow'
import BusinessLanguageUsage from '@/components/Modules/business/language_usage'
import Business from '@/components/Modules/business/main'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'ThemeFive',
      component: ThemeFive
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/forgot',
      name: 'Forgot',
      component: Forgot
    },
    {
      path: '/hiragana-sei-on',
      name: 'SeiOn Hiragana',
      component: SeiOnHiragana
    },
    {
      path: '/hiragana-daku-on',
      name: 'DakuOn Hiragana',
      component: DakuOnHiragana
    },
    {
      path: '/hiragana-handaku-on',
      name: 'HandakuOn Hiragana',
      component: HandakuOnHiragana
    },
    {
      path: '/katakana-sei-on',
      name: 'SeiOn Katakana',
      component: SeiOnKatakana
    },
    {
      path: '/number',
      name: 'Number',
      component: Numbers
    },
    {
      path: '/unit-one',
      name: 'UnitOne',
      component: UnitOne
    },
    {
      path: '/unit-two',
      name: 'UnitTwo',
      component: UnitTwo
    },
    {
      path: '/Nouns',
      name: 'Nouns',
      component: Nouns
    },
    {
      path: '/adjectives',
      name: 'Adjectives',
      component: Adjectives
    },
    {
      path: '/verbs',
      name: 'Verbs',
      component: Verbs
    },
    {
      path: '/extravocab',
      name: 'ExtraVocab',
      component: ExtraVocab
    },
    {
      path: '/tips',
      name: 'Tips',
      component: Tips
    },
    {
      path: '/greetings',
      name: 'Greetings',
      component: Greeting
    },
    {
      path: '/katakana-malaysia',
      name: 'Katakana Malaysia',
      component: Malaysia
    },
    {
      path: '/listening-hiragana',
      name: 'Listening Hiragana',
      component: ListeningHiragana
    },
    {
      path: '/listening-katakana',
      name: 'Listening Katakana',
      component: ListeningKatakana
    },
    {
      path: '/intermediate-nouns',
      name: 'Nouns',
      component: IntermediateNouns
    },
    {
      path: '/intermediate-adjectives',
      name: 'Adjectives',
      component: IntermediateAdjectives
    },
    {
      path: '/intermediate-verbs',
      name: 'Verbs',
      component: IntermediateVerbs
    },
    {
      path: '/intermediate-listening',
      name: 'Listening1',
      component: IntermediateListening
    },
    {
      path: '/business',
      name: 'business',
      component: Business
    },
    {
      path: '/business-greetings',
      name: 'greetings',
      component: BusinessGreetings
    },
    {
      path: '/business-maps',
      name: 'maps',
      component: BusinessMaps
    },
    {
      path: '/business-positions',
      name: 'positions',
      component: BusinessPositions
    },
    {
      path: '/business-bow',
      name: 'bow',
      component: BusinessBow
    },
    {
      path: '/business-language-usage',
      name: 'language-usage',
      component: BusinessLanguageUsage
    }
  ]
})
